import React from 'react';
import StylableHorizontalMenu from '../../StylableHorizontalMenu';
import { IStylableHorizontalMenuUITypeProps } from '../../../StylableHorizontalMenu.types';
import { MenuWrapperWrappable } from '../../components/MenuWrapperWrappable/MenuWrapperWrappable';
import { createSubmenuProps_column } from '../../components/MenuItem/createSubmenuProps/submenuProps_column';

const StylableHorizontalMenu_WrapColumn: React.FC<IStylableHorizontalMenuUITypeProps> =
  props => (
    <StylableHorizontalMenu
      {...props}
      menuWrapper={MenuWrapperWrappable}
      submenuProps={createSubmenuProps_column(props.className, props.menuMode)}
    />
  );

export default StylableHorizontalMenu_WrapColumn;
